import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PaginatedResponse} from '../../models/paginatedResponse';
import {Fournisseur} from '../../models/fournisseur';
import {map} from 'rxjs/operators';
import { appendErpUserStationParams } from '../erp-api-query.helper';

@Injectable({
  providedIn: 'root'
})
export class FournisseurService {
    private apiUrl = `${environment.fournisseur_url}api`;

    constructor(private http: HttpClient) {}

    getActiveFournisseur(stationId: number, page: number, limit: number): Observable<PaginatedResponse<Fournisseur>> {
        let params = new HttpParams().set('page', String(page)).set('limit', String(limit));
        params = appendErpUserStationParams(params, { stationId });
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}`, { params });
    }

    getArchivedFournisseur(stationId: number, page: number, limit: number): Observable<PaginatedResponse<Fournisseur>> {
        let params = new HttpParams().set('page', String(page)).set('limit', String(limit));
        params = appendErpUserStationParams(params, { stationId });
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}/archive`, { params });
    }

    getActiveFournisseurCount(stationId: number): Observable<number> {
        let params = new HttpParams().set('page', '1').set('limit', '1');
        params = appendErpUserStationParams(params, { stationId });
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}`, { params })
            .pipe(map(response => response.meta?.total || 0));
    }

    getArchivedFournisseurCount(stationId: number): Observable<number> {
        let params = new HttpParams().set('page', '1').set('limit', '1');
        params = appendErpUserStationParams(params, { stationId });
        return this.http.get<PaginatedResponse<Fournisseur>>(`${this.apiUrl}/fornisseurs/station/${stationId}/archive`, { params })
            .pipe(map(response => response.meta?.total || 0));
    }

    getFournisseurById(fournisseurId: number | string): Observable<Fournisseur> {
        return this.http.get<Fournisseur>(`${this.apiUrl}/fornisseurs/${fournisseurId}`);
    }

    addFournisseur(fournisseur: Fournisseur): Observable<Fournisseur> {
        return this.http.post<Fournisseur>(`${this.apiUrl}/fornisseurs`, fournisseur);
    }

    updateFournisseur(fournisseurId: number, fournisseur: Partial<Fournisseur>): Observable<Fournisseur> {
        return this.http.put<Fournisseur>(`${this.apiUrl}/fornisseurs/${fournisseurId}`, fournisseur);
    }

    archiveFournisseur(fournisseurId: number, is_archive: boolean): Observable<Fournisseur> {
        return this.http.patch<Fournisseur>(`${this.apiUrl}/fornisseurs/${fournisseurId}/archive`, { is_archive });
    }

    /**
     * Envoyer un email à un fournisseur
     * @param fournisseurId ID du fournisseur
     * @param emailData Données de l'email (to, cc, subject, message, user_id)
     */
    sendEmail(fournisseurId: number, emailData: { to: string; cc?: string; subject: string; message: string; user_id: number }): Observable<any> {
        console.log('📧 [FournisseurService.sendEmail] Envoi email pour fournisseur:', fournisseurId);
        console.log('📧 [FournisseurService.sendEmail] Données email:', emailData);
        return this.http.post(`${this.apiUrl}/fornisseurs/${fournisseurId}/send-email`, emailData);
    }
}
